import React, { useRef } from 'react';
import PropTypes from 'prop-types'
import './IFrame.scss'

export function IFrameComponent(props) {
  const iframeRef = useRef(null);

  const handleLoad = () => {
    if(iframeRef.current.src !== props.src){
      iframeRef.current.src = props.src;
    }
  };
  
  return(<iframe ref={iframeRef} src={props.src} onLoad={handleLoad}  />)
}

IFrameComponent.propTypes = {
  src: PropTypes.string
}